import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.625 2.5C5.29348 2.5 4.97554 2.6317 4.74112 2.86612C4.5067 3.10054 4.375 3.41848 4.375 3.75V16.25C4.375 16.5815 4.5067 16.8995 4.74112 17.1339C4.97554 17.3683 5.29348 17.5 5.625 17.5H14.375C14.7065 17.5 15.0245 17.3683 15.2589 17.1339C15.4933 16.8995 15.625 16.5815 15.625 16.25V8.64267C15.625 8.64264 15.625 8.64261 15.625 8.64258C15.625 8.47693 15.5591 8.31808 15.442 8.20093C15.442 8.20091 15.442 8.20089 15.442 8.20088L9.92412 2.68301C9.80696 2.56587 9.64809 2.50005 9.48242 2.5C9.48239 2.5 9.48236 2.5 9.48233 2.5H5.625ZM3.85723 1.98223C4.32607 1.51339 4.96196 1.25 5.625 1.25H9.48252C9.97962 1.25008 10.4564 1.44755 10.8079 1.79902L10.808 1.79907L16.326 7.31709C16.6774 7.66864 16.8749 8.14538 16.875 8.64248V16.25C16.875 16.913 16.6116 17.5489 16.1428 18.0178C15.6739 18.4866 15.038 18.75 14.375 18.75H5.625C4.96196 18.75 4.32607 18.4866 3.85723 18.0178C3.38839 17.5489 3.125 16.913 3.125 16.25V3.75C3.125 3.08696 3.38839 2.45107 3.85723 1.98223Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 1.5625C10.3452 1.5625 10.625 1.84232 10.625 2.1875V6.875C10.625 7.04076 10.6908 7.19973 10.8081 7.31694C10.9253 7.43415 11.0842 7.5 11.25 7.5H15.9375C16.2827 7.5 16.5625 7.77982 16.5625 8.125C16.5625 8.47018 16.2827 8.75 15.9375 8.75H11.25C10.7527 8.75 10.2758 8.55246 9.92418 8.20082C9.57254 7.84919 9.375 7.37228 9.375 6.875V2.1875C9.375 1.84232 9.65482 1.5625 10 1.5625Z",
		fill: "white"
	})]
});
export default SvgDocument;
